import React, { memo, useMemo , useEffect } from 'react';
import { useRecoilState } from 'recoil';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';
import { callFunctionDkView } from '../../helper/analyticsTag';
import { IUtag } from '../../models/IUtag';

interface IProps {
  utagData: any;
}
const Utag: React.FC<IProps> = ({ utagData }) => {
  const [,setUtagObject] = useRecoilState(utagObjectAtom)
  useEffect(() => {
    if (utagData) {
      setUtagObject(utagData as IUtag);
      
    //#region first load utag
      const newUtag = `utag_data= ${JSON.stringify(utagData)};`;

      const scriptUtag = document.createElement("script");
      scriptUtag.type = "text/javascript";
      scriptUtag.textContent = newUtag
    //#endregion

      document.body.appendChild(scriptUtag);
      return () => {
        document.body.removeChild(scriptUtag);
      }
    }
  }, [utagData]);

  useEffect(()=>{
    //#region first load GTM
    const newGTM = `
    var dataLayer = dataLayer || [];
      dataLayer.push({
      'event': 'page_view',
      'content_group1': 'Resources',
      'content_group2': 'Cross Reference Part Search',
      'page_title': 'Cross Reference Part Search',
      'page_type': 'PS',
      'page_sub_type': 'PCR',
      'page_id': 'LP'
    })
    `;
    
    const scriptGTM = document.createElement("script");
    scriptGTM.type = "text/javascript";
    scriptGTM.textContent = newGTM
  //#endregion 
    document.body.appendChild(scriptGTM);
    return () => {
      document.body.removeChild(scriptGTM);
    }
  }, [])

  const handleLoad =useMemo(()=>{
    callFunctionDkView(utagData)
  }
  ,[utagData])
  return <>{handleLoad}</>
};

export default memo(Utag);
